import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
	UsersIcon,
	DeviceMobileIcon,
	TrendingUpIcon,
	TrendingDownIcon,
	ChevronRightIcon } from '@heroicons/react/outline'

class AppEngagementCard extends Component {
	// Sparkline SVG inline (pas de librairie), 7 valeurs J-6 → J-0
	_sparkline = (daily) => {
		const values = Array.isArray(daily) && daily.length > 0 ? daily : [0, 0, 0, 0, 0, 0, 0]
		const w = 120
		const h = 36
		const max = Math.max.apply(null, values.concat([1]))
		const step = (values.length > 1) ? w / (values.length - 1) : w
		const points = values.map((v, i) => {
			const x = Math.round(i * step)
			const y = Math.round(h - (v / max) * (h - 4) - 2)
			return x + ',' + y
		})
		const area = '0,' + h + ' ' + points.join(' ') + ' ' + w + ',' + h
		return (
			<svg width={w} height={h} viewBox={'0 0 ' + w + ' ' + h} className="overflow-visible" aria-hidden="true">
				<polygon points={area} fill="#eef2ff" />
				<polyline points={points.join(' ')} fill="none" stroke="#4f46e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		)
	}

	render() {
		if (this.props.loading === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse">
					<div className="h-3 bg-slate-200 rounded-full w-1/2 mb-4"></div>
					<div className="h-8 bg-slate-200 rounded-lg w-1/3 mb-4"></div>
					<div className="h-4 bg-slate-100 rounded mb-2"></div>
					<div className="h-4 bg-slate-100 rounded w-2/3"></div>
				</div>
			)
		}
		if (this.props.error === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-2">Votre app côté campeurs</h2>
					<p className="text-sm font-medium text-slate-500 mt-0 mb-3">Données indisponibles.</p>
					<button
						type="button"
						onClick={this.props.onRetry}
						className="inline-flex items-center px-4 py-2 text-2xs font-black uppercase tracking-widest rounded-xl text-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						style={{ backgroundImage: 'none', backgroundColor: '#eef2ff' }}
					>
						Réessayer
					</button>
				</div>
			)
		}
		const visitors = this.props.visitors7d || 0
		const delta = (this.props.deltaPct === null || this.props.deltaPct === undefined) ? null : this.props.deltaPct
		const installs = this.props.installs || 0
		const trendSentence = "Évolution des visiteurs sur les 7 derniers jours" + ((delta !== null) ? ", comparée à la semaine précédente." : ".")
		let deltaPill = null
		if (delta !== null)
		{
			const pct = Math.round(delta * 100)
			const up = pct >= 0
			deltaPill = (
				<span className={"inline-flex items-center gap-0.5 text-2xs font-black px-2 py-0.5 rounded-full align-middle " + (up ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700")}>
					{up
						? <TrendingUpIcon className="w-3 h-3" aria-hidden="true" />
						: <TrendingDownIcon className="w-3 h-3" aria-hidden="true" />}
					{(up ? '+' : '') + pct}%
				</span>
			)
		}
		return (
			<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
				<div className="flex items-center justify-between mb-4">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0">Votre app côté campeurs</h2>
					<Link to="/stats" className="group flex items-center gap-1 text-2xs font-black uppercase tracking-widest text-indigo-600 hover:text-indigo-800 cursor-pointer transition-colors whitespace-nowrap">
						Voir tout
						<ChevronRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
					</Link>
				</div>
				<div className="flex items-end justify-between gap-3">
					<div>
						<div className="flex items-center gap-2 mb-1">
							<div className="w-9 h-9 rounded-xl bg-indigo-50 flex items-center justify-center flex-shrink-0">
								<UsersIcon className="w-5 h-5 text-indigo-600" aria-hidden="true" />
							</div>
							<p className="text-2xl font-black text-slate-900 my-0 leading-none">{visitors}</p>
							{deltaPill}
						</div>
						<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest my-0">Visiteurs cette semaine</p>
					</div>
					<div className="flex-shrink-0">{this._sparkline(this.props.daily)}</div>
				</div>
				<p className="text-xs font-medium text-slate-400 my-0 mt-2.5">{trendSentence}</p>
				<div className="flex items-start gap-2 mt-4 pt-4 border-t border-slate-100">
					<DeviceMobileIcon className="w-4 h-4 text-slate-400 flex-shrink-0 mt-0.5" aria-hidden="true" />
					<div className="min-w-0">
						<p className="text-sm font-semibold text-slate-600 my-0"><span className="font-black text-slate-900">{installs}</span> campeur{installs > 1 ? 's ont' : ' a'} installé l'app</p>
						<p className="text-2xs font-medium text-slate-400 my-0 mt-0.5">Total depuis le lancement · ajout à l'écran d'accueil</p>
					</div>
				</div>
			</div>
		)
	}
}

export default AppEngagementCard
